var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 6.66383C3.19796 6.6603 3.09872 6.65239 3.00948 6.63464C2.34833 6.50313 1.8315 5.9863 1.69999 5.32515C1.66797 5.16415 1.66797 4.97055 1.66797 4.58333C1.66797 4.19612 1.66797 4.00251 1.69999 3.84152C1.8315 3.18037 2.34833 2.66354 3.00948 2.53202C3.17048 2.5 3.36409 2.5 3.7513 2.5H16.2513C16.6385 2.5 16.8321 2.5 16.9931 2.53202C17.6543 2.66354 18.1711 3.18037 18.3026 3.84152C18.3346 4.00251 18.3346 4.19612 18.3346 4.58333C18.3346 4.97055 18.3346 5.16415 18.3026 5.32515C18.1711 5.9863 17.6543 6.50313 16.9931 6.63464C16.9039 6.65239 16.8046 6.6603 16.668 6.66383M8.33464 10.8333H11.668M3.33464 6.66667H16.668V13.5C16.668 14.9001 16.668 15.6002 16.3955 16.135C16.1558 16.6054 15.7734 16.9878 15.3029 17.2275C14.7682 17.5 14.0681 17.5 12.668 17.5H7.33464C5.9345 17.5 5.23444 17.5 4.69966 17.2275C4.22925 16.9878 3.8468 16.6054 3.60712 16.135C3.33464 15.6002 3.33464 14.9001 3.33464 13.5V6.66667Z",
    stroke: "#525252",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.c05b7cb5f0ac7a831c421c5c0360bcb4.svg";
export { ForwardRef as ReactComponent };